<template>
  <div class="advice-bread">
    <!-- 面包屑 -->
    <shBread>
      <shBreadItem to="/">首页</shBreadItem>
      <shBreadItem to="/advice/adviceitem"
        ><div class="bread">备考指南</div></shBreadItem
      >
    </shBread>
  </div>
  <div class="advice-item">
    <CateGory />
    <div class="advice">
      <div class="item">
        <NewsItem :adviceItem="adviceItem" />
        <div class="pagnation">
          <el-pagination
            v-model:current-page="currentPage"
            v-model:page-size="pageSize"
            @size-change="changeSize"
            @current-change="currentChange"
            :current-page="currentPage"
            :page-sizes="[15, 25, 35, 40]"
            :page-size="pageSize"
            background
            layout="total,  prev, pager, next"
            :total="adviceCount"
          >
          </el-pagination>
        </div>
      </div>
      <div class="video">
        <VideoRecommend :VideoReCommend="VideoReCommend" />
      </div>
    </div>
  </div>
</template>

<script>
import CateGory from "./components/advice-category.vue";
import NewsItem from "./components/advice-item.vue";
import { findAdviceItem } from "@/api/news";
import { findVideoRandom, findVideoRecommand } from "@/api/video";
import { useRouter, useRoute } from "vue-router";
import { nextTick, ref, watch } from "vue";
import VideoRecommend from "@/components/video-recommend.vue";
export default {
  components: { CateGory, NewsItem, VideoRecommend },
  setup() {
    const route = useRoute();
    const adviceItem = ref([]);
    //总页数
    const adviceCount = ref(0);
    //当前页码
    const currentPage = ref(1);
    //每页数
    const pageSize = ref(20);

    findAdviceItem({
      chID: route.query.firstCate,
      coID: route.query.secondCate,
      clID: route.query.thirdCate,
      size: pageSize.value,
      page: currentPage.value,
    })
      .then((data) => {
        adviceItem.value = data.result;
        adviceCount.value = data?.resultLength[0]?.totalCount;
      })
      .catch((error) => {
        console.log(error);
      });

    const currentChange = (page) => {
      currentPage.value = page;
      findAdviceItem({
        chID: route.query.firstCate,
        coID: route.query.secondCate,
        clID: route.query.thirdCate,
        size: pageSize.value,
        page: currentPage.value,
      })
        .then((data) => {
          adviceItem.value = data.result;
          adviceCount.value = data?.resultLength[0]?.totalCount;
        })
        .catch((error) => {
          console.log(error);
        });

      //console.log(page);
    };
    const changeSize = (size) => {
      pageSize.value = size;
    };
    watch(
      () => [route.query, route.fullPath],
      (newValue, oldValue) => {
        findAdviceItem({
          chID: route.query.firstCate,
          coID: route.query.secondCate,
          clID: route.query.thirdCate,
          size: pageSize.value,
          page: currentPage.value,
        })
          .then((data) => {
            adviceItem.value = data.result;
            adviceCount.value = data?.resultLength[0]?.totalCount;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    );

    const VideoReCommend = ref([]);
    //监控clID并获取相应推荐
    watch(
      () => route.query.thirdCate,
      () => {
        //获取视频推荐

        if (route.query.thirdCate) {
          const clID = route.query.thirdCate?.split(",");
          findVideoRecommand(clID)
            .then((data) => {
              VideoReCommend.value = data.map((item) => {
                return {
                  chID: item.chID,
                  maID: item.maID,
                  coID: item.coID,
                  clID: item.clID,
                  leName: item.leName,
                  leImg: "/web/" + item.leImg,
                  coverImg: "/web/" + item.coverImg,
                  grade: item.grade.find((ele) => ele._id == item.gradeID),
                  id: item._id,
                };
              });
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          findVideoRandom(10)
            .then((data) => {
              VideoReCommend.value = data.map((item) => {
                return {
                  chID: item.chID,
                  maID: item.maID,
                  coID: item.coID,
                  clID: item.clID,
                  leName: item.leName,
                  leImg: "/web/" + item.leImg,
                  coverImg: "/web/" + item.coverImg,
                  grade: item.grade.find((ele) => ele._id == item.gradeID),
                  id: item._id,
                };
              });
            })
            .catch((error) => {
              console.log(error);
            });
        }
      },
      { immediate: true }
    );
    return {
      changeSize,
      currentChange,
      adviceItem,
      currentPage,
      adviceCount,
      pageSize,
      VideoReCommend,
    };
  },
};
</script>

<style lang="less" scoped>
.advice-bread {
  background: @shColor;
  .bread {
    width: 700px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.advice-item {
  width: 1240px;
  margin: 0 auto;
  .advice {
    display: flex;
    justify-content: space-between;
    .item {
      width: 850px;
      background: #fff;
      .pagnation {
        display: flex;
        justify-content: center;
        margin-top: 25px;
        margin-bottom: 25px;
      }
    }
    .video {
      width: 350px;
      background: #fff;
    }
  }
}
</style>
